import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index'
import axios from 'axios';
import { VueAxios } from "./utils/request";

Vue.use(ElementUI)

new Vue({
  el: '#app',
  render: h => h(App),
  router
})
Vue.prototype.$axios = axios;



// WEBPACK FOOTER //
// ./src/main.js